import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class PersonService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Saves the given person object.
     *
     * @datatask 74
     * @datataskName sp_ws_p2_person_save
     * @param params the person to save.
     * @returns promise containing message.
     */
    public async savePerson(params: SavePersonParams): Promise<SavePersonResponse> {
        return (await this.datatask.Post(74, params))[0];
    }

    /**
     * Retrieves the person with the given pers no.
     *
     * @datatask 72
     * @datataskName sp_ws_p2_person_get
     * @param params retrieves the person with the given pers no.
     * @returns promise containing the person.
     */
    public async getPerson(params: GetPersonParams): Promise<PersonGet> {
        return (await this.datatask.Post(72, params))[0];
    }

    /**
     * Deletes the person which has the given pers no.
     *
     * @datatask 75
     * @datataskName sp_ws_p2_person_delete
     * @param params the pers no of the person to delete.
     * @returns promise containing a message.
     */
    public async deletePerson(params: DeletePersonParams): Promise<SavePersonResponse> {
        return (await this.datatask.Post(75, params))[0];
    }

    /**
     * Retrieves list of different phone numbers registered for the person with the given pers no.
     *
     * @datatask 73
     * @datataskName sp_ws_p2_person_phones_list
     * @param params the pers_no of the person to get phone numbers for.
     * @returns promise containing list of phone numbers.
     */
    public async getPersonsPhoneNumbers(params: GetPersonsPhoneNumbersParams): Promise<PersonPhoneNumberItem[]> {
        return this.datatask.Post(73, params);
    }

    /**
     * Retrieves list of different person facts.
     *
     * @datatask 2904
     * @datataskName sp_ws_p2_w_person_persfacts_list
     * @param params the pers_no of the person to get facts of.
     * @returns promise containing list of facts about the person.
     */
    public async getPersonFacts(params: GetPersonsFactsParams): Promise<PersonFactsItem[]> {
        return this.datatask.Post(2904, params);
    }
}

export interface GetPersonParams {
    cust_no: string | number;
    pers_no: string | number;
}

export interface PersonGet {
    cust_no: string;
    pers_no: string;
    pers_name: string;
    pers_jobtitle: string;
    pers_note: string;
    pers_email: string;
    invoice_email: '1' | '0';
    purchorder_email: '1' | '0';
    caselabel_purchase: '1' | '0';
    crm_mail: '1' | '0';
    disable_email_crm: '1' | '0';
    orderconfirm_email: '1' | '0';
    delivery_email: '1' | '0';
    cust_name: string;
    goto_edi_setup_after_saving_new_person: string;
    pers_importance: '1' | '0';
    webpage_heading: string;
}

export interface PersonPhoneNumberItem {
    phone_number: string;
    persphone_keyno: string;
    phonetype_id: string;
    phonetype_name: string;
    orderby: string;
}

export interface GetPersonsPhoneNumbersParams {
    pers_no: string | number;
}

export interface GetPersonsFactsParams {
    pers_no: string | number;
}

export interface DeletePersonParams {
    pers_no: string | number;
}

export interface PersonFactsItem {
    persfact_keyno: string;
    pers_facts_name: string;
    checkbox: '1' | '0';
    orderby: string;
    elementtype: 'N2' | 'T' | 'CB';
    number: string | number;
    note: string;
}

export interface SavePersonResponse {
    ws_result: string;
    ws_result_message: string;
}

export interface SavePersonParams extends PersonGet {
    phonenumbers?: PersonPhoneNumberItem[];
    persfacts?: PersonFactsItem[];
}
